(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.StackhouseReviewPreparation = api;
})(typeof window === 'object' ? window : this, function () {
  'use strict';
  function stable(value) {
    if (!value || typeof value !== 'object') return JSON.stringify(value);
    if (Array.isArray(value)) return '[' + value.map(stable).join(',') + ']';
    return '{' + Object.keys(value).sort().map(function (key) { return JSON.stringify(key) + ':' + stable(value[key]); }).join(',') + '}';
  }
  function reviewRequired(message) {
    var error = new Error(message || 'Your print or cart changed. Please review it again before adding.');
    error.errorCode = 'PREPARATION_REVIEW_REQUIRED';
    return error;
  }
  function create(options) {
    var now = options.now || Date.now;
    var timerSet = options.setTimeout || setTimeout;
    var timerClear = options.clearTimeout || clearTimeout;
    var desired = null, timer = null, active = null, attempt = null, stopped = false;
    function save() { if (options.save) options.save(attempt); }
    try { attempt = options.load && options.load();
      if (attempt && !attempt.product) attempt.started = true;
    } catch (_) { attempt = null; }
    function key(snapshot) { return options.key ? options.key(snapshot) : stable(snapshot); }
    function cancelTimer() { if (timer !== null) timerClear(timer); timer = null; }
    function observe(snapshot) {
      if (stopped) return;
      var next = snapshot ? key(snapshot) : '';
      if (desired && desired.key === next) return;
      cancelTimer();
      desired = snapshot ? {key: next, snapshot: JSON.parse(JSON.stringify(snapshot)), due: now() + 2000} : null;
      schedule();
    }
    function schedule() {
      if (stopped || active || attempt && attempt.writePending || !desired || desired.due === Infinity || timer !== null) return;
      timer = timerSet(function () {
        timer = null;
        var target = desired;
        if (!target) return;
        prepare(target, false).catch(function (error) {
          if (options.onBackgroundError) options.onBackgroundError(error);
        });
      }, Math.max(0, desired.due - now()));
    }
    async function prepare(target, adding, suppliedContext) {
      if (active) {
        await active.catch(function () {});
        if (!adding && (!desired || desired.key !== target.key)) return;
        return prepare(target, adding, suppliedContext);
      }
      var operation = (async function () {
        var context = suppliedContext || await options.context();
        if (!adding && (!desired || desired.key !== target.key)) return;
        var contextKey = stable(context);
        if (!attempt || attempt.key !== target.key || attempt.contextKey !== contextKey) {
          attempt = {version: 1, key: target.key, contextKey: contextKey, id: options.id(),
            body: Object.assign({}, target.snapshot, context), createdAt: now(), product: null, started: false};
          save();
        }
        var current = attempt;
        // Keep the immutable body and key even after lost responses. Only an
        // explicit Add retry retries uncertain creation, using that same attempt.
        var product = current.product;
        if (!product) {
          if (current.started && !adding) return;
          current.started = true; save();
          product = await options.request(current, false);
          current.product = product;
          save();
        }
        if (!adding && (!desired || desired.key !== target.key)) return;
        return product;
      })();
      active = operation;
      try { return await operation; }
      finally { if (active === operation) active = null; }
    }
    async function take(snapshot) {
      cancelTimer();
      var target = {key: key(snapshot), snapshot: JSON.parse(JSON.stringify(snapshot))};
      desired = {key: target.key, snapshot: target.snapshot, due: Infinity};
      var context = await options.context();
      if (active) await active.catch(function () {});
      if (attempt && attempt.key === target.key && attempt.contextKey !== stable(context)) {
        attempt = null; save(); throw reviewRequired();
      }
      if (!desired || desired.key !== target.key || stopped) throw reviewRequired();
      var product = await prepare(target, true, context);
      if (!desired || desired.key !== target.key || stopped) throw reviewRequired();
      // A completed preview is not admission. Revalidate source, quote and cart
      // on the backend immediately before the customer-triggered cart write.
      context = await options.context();
      if (attempt.contextKey !== stable(context)) throw reviewRequired();
      var validation = options.request(attempt, true, context);
      active = validation;
      try { product = await validation; }
      finally { if (active === validation) active = null; }
      if (!desired || desired.key !== target.key || stopped) throw reviewRequired();
      return product;
    }
    function settled() { if (desired && desired.due !== Infinity) schedule(); }
    // A background request may finish after its recipe becomes obsolete. It is
    // never cancelled at Shopify, and only the latest stable recipe is queued.
    var originalPrepare = prepare;
    prepare = async function (target, adding, context) {
      try { return await originalPrepare(target, adding, context); }
      finally {
        if (!adding && desired && desired.key === target.key) desired.due = Infinity;
        if (!adding) settled();
      }
    };
    function clear() { cancelTimer(); desired = null; attempt = null; save(); }
    function stop() { stopped = true; cancelTimer(); desired = null; }
    return {observe: observe, take: take, clear: clear, stop: stop,
      pendingWrite: function () { return attempt && attempt.writePending ? attempt : null; },
      markWrite: function () { if (attempt) { attempt.writePending = true; save(); } },
      cancelWrite: function () { if (attempt) { attempt.writePending = false; save(); } }
    };
  }
  return {create: create, stable: stable, reviewRequired: reviewRequired};
});
